import axios from "../../../../../axios";
import React from "react";
import { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import PreDraftAttach from "../../Draft/Draft_Assess_Box/Draft_Q_list/PreDraftAttach";
import DraftPublishPreRead from "../../Draft/Draft_Assess_Box/DraftPreReadPublish/DraftPublishPreRead";
import { Form } from "react-bootstrap";
// all css comes From Draft_Q_list_PreRead.css
const Published_EditPre = () => {
  const navigate = useNavigate();
  const { publicPreread_id } = useParams();
  const [publish, setPublish] = useState();
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  const [updatePreread, setUpdatePreread] = useState({
    description: "",
    updateTittle: "",
    updateDeadline: "",
    updateScheduleDate: "",
    updateScheduleTime: "",
    attach: [],
  });
  const {
    description,
    attach,
    updateTittle,
    updateDeadline,
    updateScheduleDate,
    updateScheduleTime,
  } = updatePreread;
  const [prePublishData, setprePublishtData] = useState({
    PublishPreRead: [],
  });
  const { PublishPreRead } = prePublishData;

  useEffect(() => {
    const getPublishPreRead = async () => {
      try {
        const res = await axios.get(
          `/api/v1/homework/preRead/getById/${publicPreread_id}`
        );
        res &&
          setprePublishtData({
            PublishPreRead: res.data.data,
          });
        setUpdatePreread({
          ...updatePreread,
          description: res?.data.data.description,
          updateTittle: res?.data.data.name,
          attach: res?.data.data.attachments,
          updateDeadline: res?.data.data.deadline,
          updateScheduleDate: res?.data.data.schedule_date,
          updateScheduleTime: res?.data.data.schedule_time,
        });
      } catch (error) { }
    };
    getPublishPreRead();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publicPreread_id]);
  let createPreRead = {
    standard_id: PublishPreRead?.standard_id?.id,
    subject_id: PublishPreRead?.subject_id?.id,
    section_id: PublishPreRead?.section_id?.id,
    book_id: PublishPreRead?.book_id?.id,
    chapter_id: PublishPreRead?.chapter_id?.id,
    type: PublishPreRead?.type?.id,
    teacher_id: Teacher_Json,
    status: "draft",
    description: description,
    name: updateTittle,
    attachments: attach,
    deadline: updateDeadline,
    schedule_date: updateScheduleDate,
    schedule_time: updateScheduleTime,
  };

  // const handleClick = async () => {
  //   if (attach) {
  //     const formData = new FormData();
  //     formData.append("name", attach.name);
  //     formData.append("uploadPreReadAttachment", attach);
  //     try {
  //       const res = await axios.post(
  //         `/api/v1/preRead/uploadAttachment/teacherId/${Teacher_Json}`,

  //         formData
  //       );
  //       createPreRead.attachments = res.data.data;
  //     } catch (error) {}
  //   }
  // };
  const myFileInput = document.getElementById("attachFile");
  myFileInput?.addEventListener("change", (event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("uploadPreReadAttachment", file);
    axios
      .post(
        `/api/v1/preRead/uploadAttachment/teacherId/${Teacher_Json}`,
        formData
      )
      .then((response) => {
        createPreRead.attachments = response.data.data;
        setUpdatePreread({
          ...updatePreread,
          attach: [response.data.data],
        });
        // setUserAttach([response.data.data]);
        // setAttach([response.data.data]);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  });
  const helper = async () => {
    try {
      let res = await axios.post(
        `/api/v1/homework/preRead/update/${PublishPreRead.id}`,
        createPreRead
      );
      console.log(res);
      navigate("/PublishedHomeworkPreRead");
    } catch (error) {
      console.log(error);
    }
  };

  const isDisableButton =
    updatePreread.updateTittle === "" || updatePreread.description === "";

  const titleRejex = /^\s+/;
  const descriptionRejex = /^\s+/;

  const errors = {};
  if (updateTittle === (titleRejex.test(updateTittle) && updateTittle)) {
    errors.updateTittle = "Tittle can not start with a space";
  }
  if (description === (descriptionRejex.test(description) && description)) {
    errors.description = "Description can not start with a space";
  }
  return (
    <>
      <div className="draft_preRead_all">
        <div className="d-flex align-items-center ">
          <Link to="/PublishedHomeworkPreRead">
            <img src="/images/Back Arrow.svg" alt="" />
          </Link>
          <Link to="/PublishedHomeworkPreRead" className="link">
            <span className="open_publish_path_pre">
              &nbsp; {PublishPreRead?.status} /&nbsp;
            </span>
          </Link>
          <span className="open_publish_path1_pre">
            edit {PublishPreRead?.name}
          </span>
        </div>

        <div class="Draft-text">
          <input
            type="text"
            value={updateTittle}
            placeholder="Enter title"
            class="txt_draftName mt-3 form-control"
            id="txt-i-first"
            onChange={(e) =>
              setUpdatePreread({
                ...updatePreread,
                updateTittle: e.target.value,
              })
            }
          />
          {errors.updateTittle && (
            <span className="error">{errors.updateTittle}</span>
          )}
          <Form.Control
            as="textarea"
            placeholder="Enter Description"
            value={description}
            rows={4}
            className="px-3 py-2 mt-4 txt_draftdesc"
            onChange={(e) =>
              setUpdatePreread({
                ...updatePreread,
                description: e.target.value,
              })
            }
          />
          {errors.description && (
            <span className="error">{errors.description}</span>
          )}
        </div>
        <div className="AttachIcon_preRead_draft mt-3 me-3 gap-3 d-flex align-items-center justify-content-between ">
          <div>
            <input
              id="attachFile"
              type="file"
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              style={{ display: "none" }}
              onChange={(e) =>
                setUpdatePreread({
                  ...updatePreread,
                  attach: e.target.files[0],
                })
              }
            />
            <label
              className="d-flex align-items-center gap-1 "
              htmlFor="attachFile"
            >
              <div className=" px-3 py-2 d-flex align-items-center justify-content-center prered_attach box">
                <img src="/images/Attach.svg" alt="" />
                <span className="activity_attach">&nbsp;Attach</span>
              </div>
            </label>
          </div>
        </div>

        <div className="editSchedule_pdf_container_prepread">
          {attach && attach.length !== 0 && (
            <PreDraftAttach
              setAttach={setUpdatePreread}
              updatePreread={updatePreread}
              attachData={PublishPreRead}
              attach={attach}
            />
          )}
        </div>
      </div>
      <div className="d-flex justify-content-end editPreBtn">
        <button
          className="btn px-3 m-1 py-2 pre_QDraft_button"
          onClick={() => {
            // handleClick();
            helper();
          }}
          disabled={isDisableButton}
        >
          Save as Draft
        </button>

        <button
          className="btn m-1 py-2 prer_Qnext_button"
          onClick={(e) => setPublish(true)}
          disabled={isDisableButton}
        >
          Publish
        </button>
      </div>

      {publish && (
        <DraftPublishPreRead
          setPublish={setPublish}
          newPreRead={PublishPreRead}
          updatePreread={updatePreread}
        />
      )}
    </>
  );
};

export default Published_EditPre;
